export enum TimeZoneInfoActionTypes {
    SET_TIME_ZONE_INFO = "SET_TIME_ZONE_INFO",
    CLEAR_TIME_ZONE_INFO = "CLEAR_TIME_ZONE_INFO"
}